(function () {
  var INTRO_READY_CLASS = 'is-intro-ready';
  var INTRO_VISIBLE_CLASS = 'is-intro-visible';
  var OBSERVED_ATTR = 'data-ug-sr-intro-observed';

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function revealIntro(target) {
    target.classList.add(INTRO_VISIBLE_CLASS);
  }

  function prepareIntro(target) {
    target.classList.add(INTRO_READY_CLASS);
  }

  function revealIntroSoon(target) {
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        revealIntro(target);
      });
    });
  }

  function observeIntro(target) {
    if (!target || target.getAttribute(OBSERVED_ATTR) === '1') return;
    target.setAttribute(OBSERVED_ATTR, '1');

    if (prefersReducedMotion()) {
      revealIntro(target);
      return;
    }

    prepareIntro(target);

    if (target.getAttribute('data-ug-sr-intro') === 'immediate') {
      revealIntroSoon(target);
      return;
    }

    if (!('IntersectionObserver' in window)) {
      revealIntro(target);
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          revealIntro(entry.target);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -28% 0px',
        threshold: 0
      }
    );

    observer.observe(target);
  }

  function scan(scope) {
    var root = scope && scope.querySelectorAll ? scope : document;
    if (root.matches && root.matches('[data-ug-sr-intro]')) observeIntro(root);
    root.querySelectorAll('[data-ug-sr-intro]').forEach(observeIntro);
  }

  function init() {
    scan(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) scan(event.target);
  });
})();
